import React from "react";
var __jsx = React.createElement;
import stl from "./TimeSlot.module.css";
import SingleTimeSlote from "./SingleTimeSlote";
import { useState } from "react";
import { useEffect } from "react";
import { createTimestampAndNextNDays } from "@/utils/GlobalJavascriptFunction";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useTranslation } from "@i18n";
var TimeSlot = function TimeSlot(_ref) {
  var availableDayTimes = _ref.availableDayTimes,
    _updateSeletedDayAndTime = _ref.updateSeletedDayAndTime,
    errorAppointment = _ref.errorAppointment,
    updatError = _ref.updatError,
    isUserLocation = _ref.isUserLocation;
  var _useState = useState(null),
    activeSlot = _useState[0],
    setAactiveSlot = _useState[1];
  var lang = useLang();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    setAactiveSlot(null);
  }, [availableDayTimes]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, availableDayTimes && /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("strong", null, t("available_appointments", {
    ns: "web_Schedule"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.allTimeSlots
  }, availableDayTimes === null || availableDayTimes === void 0 ? void 0 : availableDayTimes.map(function (time, idx) {
    return /*#__PURE__*/React.createElement(SingleTimeSlote, {
      text: "".concat(createTimestampAndNextNDays(time.from_timestamp).timeForView(lang), " - ").concat(createTimestampAndNextNDays(time.to_timestamp).timeForView(lang)),
      disabled: !time.is_active,
      active: activeSlot === idx,
      updateTime: function updateTime() {
        return setAactiveSlot(idx);
      },
      updateSeletedDayAndTime: function updateSeletedDayAndTime() {
        _updateSeletedDayAndTime({
          from: time === null || time === void 0 ? void 0 : time.from_timestamp,
          to: time === null || time === void 0 ? void 0 : time.to_timestamp
        });
        updatError();
      }
    });
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.note
  }, isUserLocation ? t("inspection_hours_start_9_30", {
    ns: "web_Schedule"
  }) : t("inspection_hours_start_9_am", {
    ns: "web_Schedule"
  })), errorAppointment && /*#__PURE__*/React.createElement("div", {
    className: stl.bigNote
  }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, t("appointment_booked_another_client", {
    ns: "web_Schedule"
  })), /*#__PURE__*/React.createElement("p", null, t("book_another_appointment", {
    ns: "web_Schedule"
  }))))), !availableDayTimes && /*#__PURE__*/React.createElement("div", {
    className: stl.noDataHolder
  }));
};
export default TimeSlot;